import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

/** Sites wizard gate: login required; emulator skips verify-email. */
export function SitesRoute({ children }) {
  const { currentUser, loading } = useAuth();
  const emulator = process.env.REACT_APP_USE_EMULATORS === 'true';

  if (loading) {
    return (
      <div style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        Loading…
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (!emulator && !currentUser.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  return children;
}
